// Auto-generated normalizer for table: Cat_UnidadesOrg
export function catUnidadesOrgNormalize(row) {
  const idTipo =
    row.idTipoUnidadOrganizacional ??
    row.IdTipoUnidadOrganizacional ??
    row.idTipoUndiadOrganizacional ??
    row.IdTipoUndiadOrganizacional ??
    0;

  return {
    idZonaGeografica: row.idZonaGeografica ?? row.IdZonaGeografica ?? row["idZonaGeografica"] ?? 0,
    idUnidadOrganizacional: row.idUnidadOrganizacional ?? row.IdUnidadOrganizacional ?? row['IdUnidadOrganizacional'] ?? 0,
    idDireccion: row.idDireccion ?? row.IdDireccion ?? row['IdDireccion'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    idTipoUnidadOrganizacional: idTipo,
    idTipoUndiadOrganizacional: idTipo, // Alias para compatibilidad
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
